import BookIndex from "components/shared/book/list";
import SharedReactTable from "components/shared/reactTable";
import { rowIndexColumn } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import React from "react";

class TrackersInfoList extends BookIndex {
    get tableColumns() {
        return [
            rowIndexColumn,
            { Header: "Организация", accessor: "organizationName", filterable: true },
            { Header: "Общее кол-во машин", accessor: "carsWithTrackerCount", filterable: true, filterType: "int" },
            {
                Header: "Кол-во машин без координат (1ч.)",
                accessor: "carsWithoutCoordinatesIn1HourCount",
                filterable: true,
                filterType: "int",
                Cell: ({
                    value,
                    row: {
                        original: { percentOfCarsWithoutCoordinatesIn1Hour },
                    },
                }) => `${value} (${percentOfCarsWithoutCoordinatesIn1Hour}%)`,
                CSVExport: ({ value, original: { percentOfCarsWithoutCoordinatesIn1Hour } }) =>
                    `${value} (${percentOfCarsWithoutCoordinatesIn1Hour}%)`,
            },
            {
                Header: "Кол-во машин без координат (3ч.)",
                accessor: "carsWithoutCoordinatesIn3HoursCount",
                filterable: true,
                filterType: "int",
                Cell: ({
                    value,
                    row: {
                        original: { percentOfCarsWithoutCoordinatesIn3Hours },
                    },
                }) => `${value} (${percentOfCarsWithoutCoordinatesIn3Hours}%)`,
                CSVExport: ({ value, original: { percentOfCarsWithoutCoordinatesIn3Hours } }) =>
                    `${value} (${percentOfCarsWithoutCoordinatesIn3Hours}%)`,
            },
            {
                Header: "Кол-во машин без координат (24ч.)",
                accessor: "carsWithoutCoordinatesIn24HoursCount",
                filterable: true,
                filterType: "int",
                Cell: ({
                    value,
                    row: {
                        original: { percentOfCarsWithoutCoordinatesIn24Hours },
                    },
                }) => `${value} (${percentOfCarsWithoutCoordinatesIn24Hours}%)`,
                CSVExport: ({ value, original: { percentOfCarsWithoutCoordinatesIn24Hours } }) =>
                    `${value} (${percentOfCarsWithoutCoordinatesIn24Hours}%)`,
            },
        ];
    }

    renderListComponent = () => <SharedReactTable {...this.props} columns={this.state.tableColumns} />;
}

export default tableContainer(TrackersInfoList, "trackersinfo");
